import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../helpers/Arrays";
import whyImage from "../../assets/codeChamps/why_code_champs.png";
import timelineImage from "../../assets/codeChamps/timeline_code_champs.png";

const CodeChampsTemplate = () => {
  const navigate = useNavigate();
  return (
    <Box
      id={"codechamps"}
      sx={{
        width: "100%",
        maxWidth: "1500px",
        margin: "auto",
        padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
      }}
    >
      <Typography
        variant={"h1"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "40px", sm: "55px" },
          fontWeight: "500",
          color: "primary.darker",
        }}
      >
        CodeChamps Tracks
      </Typography>
      <Box
        sx={{
          height: "3px",
          maxWidth: { xs: "100px", md: "200px" },
          width: "100%",
          backgroundColor: "primary.main",
          margin: "10px auto 0 auto",
        }}
      />
      
      <Box sx={{ marginTop: "40px" }}>
        <img
          src={whyImage}
          alt="Why CodeChamps"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </Box>

      <Box sx={{ height: "2px", width: "100%", backgroundColor: "primary.main", margin: "30px 0" }} />

      <Box>
        <img
          src={timelineImage}
          alt="CodeChamps Timeline"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </Box>

      <Box sx={{ height: "2px", width: "100%", backgroundColor: "primary.main", margin: "30px 0" }} />

      <Grid
        container
        spacing={2}
        sx={{ justifyContent: "center" }}
      >
        {categoriesData?.map((item, index) => (
          <Grid item xs={12} md={6} xl={6} key={index}>
            <Box
              sx={{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4)), url(${item.imageW})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                width: "100%",
                minHeight: { xs: "200px", sm: "300px" },
                borderRadius: "10px",
              }}
            >
              <Typography
                variant={"h3"}
                sx={{
                  textAlign: "center",
                  fontSize: "35px",
                  fontWeight: "500",
                  color: "secondary.main",
                }}
              >
                {item.title}
              </Typography>
              <Box
                sx={{
                  height: "3px",
                  maxWidth: "90px",
                  width: "100%",
                  backgroundColor: "secondary.main",
                  margin: "5px auto 5px auto",
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "primary.main",
                    width: "fit-content",
                    margin: { xs: "5px 0 20px 0", sm: "10px 0 20px 0" },
                  }}
                  onClick={() => navigate(item.link)}
                >
                  view more
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CodeChampsTemplate;

